import React from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {makeStyles} from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import FlashOn from '@material-ui/icons/FlashOn';

import * as GameActions from '../redux/actions/game_actions';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  vowelButton: {
    marginTop: '5px',
    marginLeft: '5px',
    marginRight: '5px',
  },
  button: {
    marginRight: '5px',
  },
  vowelBar: {
    height: '2em',
  },
}));

export default function VowelBox() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const vowels = useSelector((state) => state.game.vowels);
  const isVowelMaxed = useSelector((state) => state.game.isVowelMaxed);
  const energy = useSelector((state) => state.game.energy);

  const areVowelsDisabled = isVowelMaxed || energy < 3;

  return (
    <Paper>
      <Box>
        <Button onClick={() => dispatch(GameActions.vowel())} className={classes.vowelButton} disabled={areVowelsDisabled} variant="contained" color="primary">
          Get Vowel  (2<FlashOn />)
        </Button>
      </Box>
      <Box p={2} className={classes.vowelBar}>
        <Typography>
          {vowels.map((letter, index) => (
            <Button
              className={classes.button}
              onClick={() => dispatch(GameActions.takeVowel(index))}
              disabled={letter.val.val === ''}
              key={`vowel-${index}`}
              size="small"
              variant="contained">
              {letter.val.val}
            </Button>
          ))}
        </Typography>
      </Box>
    </Paper>
  );
};
